import React, { FC } from 'react';
import { Menu, TextFieldSize, Icon, IconSize, MenuOptions, Box } from '@bechtel/gds';
import { MenuButtonStyled, MenuItemStyled, PopperContainerStyled } from './styled';
import { PermissionMenu, PermissionMenuType, PermissionActionsProps } from './types';
import { map } from 'lodash';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';

const permissionMenuItems: PermissionMenu[] = [
  { label: t`Expand/Collapse All`, type: PermissionMenuType.EXPAND_COLLAPSE_ALL },
  { label: t`Restore Default Permissions`, type: PermissionMenuType.RESTORE_DEFAULT_PERMISSIONS },
  { label: t`Download .CSV`, type: PermissionMenuType.DOWNLOAD_CSV },
];

export const PermissionActions: FC<PermissionActionsProps> = ({ onMenuSelect }) => {
  const { i18n } = useLingui();
  return (
    <Menu>
      {({ isOpen, toggle, close: closeMenu }) => (
        <div
          style={{ position: 'relative' }}
          onBlur={() => {
            closeMenu();
          }}
        >
          <div>
            <MenuButtonStyled
              onClick={() => {
                toggle();
              }}
              size={TextFieldSize.MEDIUM}
            >
              <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }}>
                <Icon icon="ellipsis-v" size={IconSize.MEDIUM} fillColor="blue.800" />
              </Box>
            </MenuButtonStyled>
          </div>
          <PopperContainerStyled>
            {isOpen && (
              <MenuOptions>
                <Box flexDirection={{ sm: 'row' }}>
                  <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
                    {map(permissionMenuItems, (item) => {
                      return (
                        <MenuItemStyled
                          key={item.label}
                          isDisabled={item.type === PermissionMenuType.DOWNLOAD_CSV}
                          onMouseDown={(event) => {
                            onMenuSelect(item.type);
                            closeMenu();
                            event.preventDefault();
                          }}
                        >
                          {i18n._(item.label)}
                        </MenuItemStyled>
                      );
                    })}
                  </Box>
                </Box>
              </MenuOptions>
            )}
          </PopperContainerStyled>
        </div>
      )}
    </Menu>
  );
};
export default PermissionActions;
